import { API_URLS } from '@helpers/api';
import { withQueryParams } from '@hoc/withQueryParams';
import { useApi } from '@hooks/useApi';
import MarketplaceCard from '@stories/Components/Cards/MarketplaceCard/MarketplaceCard';
import FilterTabButtons from '@stories/Components/Misc/FilterTabButtons/FilterTabButtons';
import LoadingIndicator from '@stories/Components/Misc/LoadingIndicator/LoadingIndicator';
import Pagination from '@stories/Components/Misc/Pagination/Pagination';
import qs from 'qs';
import * as React from 'react';
import { NumberParam, StringParam, useQueryParams, withDefault } from 'use-query-params';
import S from './MarketplaceList.styles';
const MarketplaceList = (props) => {
    const resultsRef = React.useRef(null);
    const [params, setParams] = useQueryParams(Object.assign({
        pageIndex: withDefault(NumberParam, 1),
        pageSize: withDefault(NumberParam, 9),
        category: withDefault(StringParam, ''),
    }));
    const result = useApi({
        initialData: props.initialData,
        url: `${API_URLS.marketplaceList}?${qs.stringify(params)}`,
    });
    return (React.createElement(S.Container, { "data-loading": result.status === 'loading' },
        props.filters && props.filters.length > 0 && (React.createElement(FilterTabButtons, { buttons: props.filters, active: params.category, onButtonClick: (value) => setParams({ pageIndex: 1, category: value }, 'push'), hideActiveDotMobile: true })),
        result.data && (React.createElement(React.Fragment, null,
            renderResults(),
            React.createElement(Pagination, { disabled: result.status === 'loading', currentPage: params.pageIndex, pageCount: Math.ceil(result.data.totalCount / params.pageSize), onChange: (p) => {
                    setParams({ pageIndex: p }, 'pushIn');
                    /** timeout required to ensure scrolling occurs on prev/next buttons */
                    setTimeout(() => resultsRef.current?.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                        inline: 'start',
                    }), 50);
                }, translations: props.translations }))),
        result.status === 'loading' && (React.createElement(LoadingIndicator, { label: props.translations?.['listings.loading'] ?? 'Loading…', layout: "fixed" }))));
    function renderResults() {
        return (React.createElement(S.ItemsWrapper, { ref: resultsRef }, !result.data?.items?.length ? (React.createElement(S.NoResultsText, null, "No results found.")) : (React.createElement(React.Fragment, null, result.data.items.map((item) => (React.createElement(MarketplaceCard, { key: item.id, ...item })))))));
    }
};
export default withQueryParams(MarketplaceList);
